// The ids a <Field> gives its hint and error, so the control inside can point at them:
//
//   <Field id={id} label={…} hint={…} error={invalid ? t('…') : undefined}>
//     <Input id={id} aria-invalid={invalid || undefined}
//       aria-describedby={fieldDescribedBy(id, { hint: true, error: invalid })} />
//   </Field>
//
// Field doesn't set `aria-invalid` / `aria-describedby` itself: when a control is marked invalid differs per form
// (on submit, on blur, only some fields), so the page keeps that rule and uses these ids.

/** The id of a Field's hint line. */
export const fieldHintId = (id: string): string => `${id}-hint`;

/** The id of a Field's error line. */
export const fieldErrorId = (id: string): string => `${id}-error`;

/**
 * The control's `aria-describedby`: the hint's id when it shows, then the error's id when it shows, space-separated;
 * `undefined` when neither shows (so the attribute is left out).
 */
export function fieldDescribedBy(id: string, shown: { hint?: boolean; error?: boolean }): string | undefined {
  const ids = [shown.hint && fieldHintId(id), shown.error && fieldErrorId(id)].filter(Boolean);
  return ids.length ? ids.join(' ') : undefined;
}
